import { createRouter, createWebHashHistory } from 'vue-router';
import { fetchProfile } from '@/stores/session';

const routes = [
  {
    path: '/',
    name: 'public-home',
    component: () => import('@/views/public/HomeView.vue'),
    meta: {
      title: '在线预约'
    }
  },
  {
    path: '/member/login',
    name: 'member-login',
    component: () => import('@/views/public/MemberLoginView.vue'),
    meta: {
      title: '会员登录'
    }
  },
  {
    path: '/member/center',
    name: 'member-center',
    component: () => import('@/views/public/MemberCenterView.vue'),
    meta: {
      requiresAuth: true,
      memberOnly: true,
      title: '会员中心'
    }
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import('@/views/admin/LoginView.vue'),
    meta: {
      title: '系统登录'
    }
  },
  {
    path: '/admin',
    component: () => import('@/components/layout/AdminLayout.vue'),
    meta: {
      requiresAuth: true,
      backendOnly: true
    },
    children: [
      {
        path: '',
        redirect: '/admin/dashboard'
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: () => import('@/views/admin/DashboardView.vue'),
        meta: {
          requiresAuth: true,
          backendOnly: true,
          title: '经营看板',
          description: '查看今日预约、门店营收和热门项目的整体情况'
        }
      },
      {
        path: 'members',
        name: 'admin-members',
        component: () => import('@/views/admin/MembersView.vue'),
        meta: {
          requiresAuth: true,
          backendOnly: true,
          title: '会员管理',
          description: '维护会员资料、等级、余额与到店信息'
        }
      },
      {
        path: 'services',
        name: 'admin-services',
        component: () => import('@/views/admin/ServicesView.vue'),
        meta: {
          requiresAuth: true,
          backendOnly: true,
          title: '服务项目',
          description: '维护项目价格、预计时长与上架状态'
        }
      },
      {
        path: 'employees',
        name: 'admin-employees',
        component: () => import('@/views/admin/EmployeesView.vue'),
        meta: {
          requiresAuth: true,
          backendOnly: true,
          title: '员工管理',
          description: '查看美甲师与门店员工的可约状态和擅长方向'
        }
      },
      {
        path: 'appointments',
        name: 'admin-appointments',
        component: () => import('@/views/admin/AppointmentsView.vue'),
        meta: {
          requiresAuth: true,
          backendOnly: true,
          title: '预约管理',
          description: '录入预约、核对时间冲突并维护预约状态'
        }
      },
      {
        path: 'finance',
        name: 'admin-finance',
        component: () => import('@/views/admin/FinanceView.vue'),
        meta: {
          requiresAuth: true,
          backendOnly: true,
          title: '充值消费',
          description: '记录会员充值、到店消费和余额抵扣情况'
        }
      },
      {
        path: 'users',
        name: 'admin-users',
        component: () => import('@/views/admin/AccountsView.vue'),
        meta: {
          requiresAuth: true,
          backendOnly: true,
          adminOnly: true,
          title: '账号管理',
          description: '仅管理员可维护后台账号信息'
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) {
    return true;
  }

  try {
    const user = await fetchProfile();
    if (!user) {
      throw new Error('missing user');
    }

    if (to.meta.memberOnly && user.role !== 'MEMBER') {
      return '/member/login';
    }

    if (to.meta.backendOnly && user.role !== 'ADMIN') {
      return user.role === 'MEMBER' ? '/member/center' : '/admin/login';
    }

    if (to.meta.adminOnly && user.role !== 'ADMIN') {
      return '/admin/dashboard';
    }

    return true;
  } catch (error) {
    if (to.meta.memberOnly) {
      return {
        path: '/member/login',
        query: {
          redirect: to.fullPath
        }
      };
    }
    return {
      path: '/admin/login',
      query: {
        redirect: to.fullPath
      }
    };
  }
});

export default router;
